module.exports = __webpack_public_path__ + "img/TOP3.b7095b31.png";